<div *ngIf="lvt?.cameraId" id="lvt-{{ lvt.cameraId }}">
  <div id="video-container-{{ lvt.cameraId }}">
    <div class="fs-position-relative">
      <div class="video-player-ratio">
        <video class="video-player" id="webrtc-video-{{ lvt.cameraId }}" autoplay></video>
      </div>
      <div *ngIf="isFullscreen" id="top-overlay" class="top-overlay-container">
        <a>SOUNDS: </a>
        <sn-button *ngFor="let sound of soundList" (click)="playSound(sound)" color="success">{{
          sound.name
        }}</sn-button>
        <a>LIGHTS: </a>
        <sn-button *ngFor="let light of lightList" (click)="playLight(light)" color="accent">{{
          light.name
        }}</sn-button>
      </div>

      <div
        *ngIf="showDragControls()"
        id="ptzOverlay"
        [class.crosshairCursor]="isCrosshairEnabled"
        (contextmenu)="handleRightClicks($event)"
        (mousedown)="startAreaZoomDrawing($event)"
        (click)="centerOnClick($event)"
        (mousewheel)="onScrollZoom($event)"
      >
        <div
          *ngIf="showDragControls()"
          class="crosshairBoundary"
          [class.seeThrough]="isCrosshairEnabled || isAreaZoomDrawing"
          (mouseenter)="showCanvas()"
          (mouseleave)="hideCanvas()"
        ></div>

        <div class="movingPrompt" *ngIf="isDragging">
          <span>
            Moving<span class="ellipsis-anim"><span>.</span><span>.</span><span>.</span></span>
          </span>
        </div>
        <svg id="areaZoomSvg" width="100%" height="100%"></svg>
        <canvas
          [class.ptzCrosshairOff]="false"
          [class.seeThrough]="isCrosshairEnabled"
          [class.hideCrosshair]="!isFullscreen"
          (mousedown)="startDrawing($event)"
          (mouseup)="stopDrawing()"
          (mouseenter)="showCanvas()"
          (mouseleave)="hideCanvas()"
          id="ptzCrosshair"
          width="80"
          height="80"
        ></canvas>
        <svg
          *ngIf="isCrosshairEnabled"
          class="shapeCanvas"
          [class.seeThrough]="isAreaZoomDrawing"
          (mousemove)="keepDrawing($event)"
          (mouseup)="stopDrawing()"
          (mouseleave)="stopDrawing()"
        >
          <ng-container *ngFor="let line of linesToDraw">
            <line
              class="shape"
              *ngIf="line.type === 'line'"
              [attr.x1]="line.x"
              [attr.y1]="line.y"
              [attr.x2]="line.x * 1 + line.w * 1"
              [attr.y2]="line.y * 1 + line.h * 1"
            ></line>
          </ng-container>
        </svg>
      </div>

      <div
        *ngIf="streamStarted"
        [ngClass]="isFullscreen ? 'fullscreen-bottom-overlay' : 'bottom-overlay'"
        class="stream-started-container"
      >
        <span>
          <sn-icon-button
            *ngIf="isPlaying"
            (click)="playButton()"
            id="play-btn"
            matTooltipPosition="above"
          >
            <sn-icon size="md" class="yellow-text">play_arrow</sn-icon>
          </sn-icon-button>
          <sn-icon-button
            *ngIf="!isPlaying"
            (click)="playButton()"
            id="play-btn"
            matTooltipPosition="above"
          >
            <sn-icon size="md" class="yellow-text">pause</sn-icon>
          </sn-icon-button>
          <sn-icon-button
            *ngIf="!isMuted"
            (click)="muteButton()"
            id="play-btn"
            matTooltipPosition="above"
          >
            <sn-icon size="md" class="yellow-text">volume_up</sn-icon>
          </sn-icon-button>
          <sn-icon-button
            *ngIf="isMuted"
            (click)="muteButton()"
            id="play-btn"
            matTooltipPosition="above"
          >
            <sn-icon size="md" class="yellow-text">volume_off</sn-icon>
          </sn-icon-button>
        </span>
        <sn-icon-button
          *ngIf="!isFullscreen"
          (click)="fullscreenButton()"
          id="mute-btn"
          matTooltipPosition="above"
        >
          <sn-icon size="md" class="yellow-text">fullscreen</sn-icon>
        </sn-icon-button>
        <sn-icon-button
          *ngIf="isFullscreen"
          (click)="fullscreenButton()"
          id="mute-btn"
          matTooltipPosition="above"
        >
          <sn-icon size="md" class="yellow-text">fullscreen_exit</sn-icon>
        </sn-icon-button>
      </div>
    </div>
  </div>
</div>
